import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import i18n from '../../../../i18n';
const FIELD_LABELS = {
  rop_approval: i18n.t('rop_approval'),
  invoice_send: i18n.t('invoice_send'),
  paid: i18n.t('paid'),
  paid_guarantee: i18n.t('paid_guarantee'),
  approval_paper: i18n.t('approval_paper'),
  items_received: i18n.t('items_received'),
  rop_paid: i18n.t('rop_paid'),
  feedback: i18n.t('feedback'),
};

export default function AuctionStatusForm({ formData, onToggle, onRemarkChange }) {
  return (
    <Form>
      {Object.keys(formData).map((field) => (
        <Row key={field} className="align-items-center mb-3">
          <Col xs={4}>
            <p className="text-capitalize">
              {FIELD_LABELS[field] || field} {/* Fallback to field name if label missing */}
            </p>
          </Col>
          <Col xs={2}>
            <Form.Check
              type="switch"
              id={`switch-${field}`}
              checked={formData[field].value}
              onChange={() => onToggle(field)}
            />
          </Col>
          <Col xs={6}>
            <Form.Control
              type="text"
              placeholder="Enter remark"
              value={formData[field].remark}
              onChange={(e) => onRemarkChange(field, e.target.value)}
            />
          </Col>
        </Row>
      ))}
    </Form>
  );
}
